import fixWebmDuration from "fix-webm-duration";
import { api } from "@/lib/api";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

// Chrome's MediaRecorder writes WebM without a duration, which breaks seeking.
async function withDuration(blob, ms) {
  if (!blob.type.includes("webm") || !ms) return blob;
  try { return await fixWebmDuration(blob, ms, { logger: false }); } catch { return blob; }
}

// Uploads an answer video; first try + up to 3 retries. Never blocks the interview.
export async function uploadVideo(token, number, take, raw, onState, ms) {
  const blob = await withDuration(raw, ms);
  const ext = blob.type.includes("mp4") ? "mp4" : "webm";
  for (let attempt = 0; attempt <= 3; attempt += 1) {
    onState("uploading");
    try {
      const fd = new FormData();
      fd.append("question_number", String(number));
      fd.append("take", String(take));
      fd.append("video", blob, `answer.${ext}`);
      await api.post(`/public/interview/${token}/voice/video`, fd, { timeout: 120000 });
      onState("saved");
      return true;
    } catch (e) {
      const s = e?.response?.status;
      if (s && s < 500 && s !== 408 && s !== 429) break;
      if (attempt < 3) await wait(1500 * 2 ** attempt);
    }
  }
  onState("failed");
  return false;
}

// Uploads the single live-interview recording with progress; first try + up to 3 retries.
export async function uploadRecording(token, { blob: raw, ms }, onPct) {
  const blob = await withDuration(raw, ms);
  const ext = blob.type.includes("mp4") ? "mp4" : "webm";
  for (let attempt = 0; attempt <= 3; attempt += 1) {
    try {
      const fd = new FormData();
      fd.append("duration_ms", String(ms || 0));
      fd.append("video", blob, `interview.${ext}`);
      await api.post(`/public/interview/${token}/live/recording`, fd, { timeout: 600000, onUploadProgress: (e) => e.total && onPct(Math.round((100 * e.loaded) / e.total)) });
      onPct(100);
      return true;
    } catch (e) {
      const s = e?.response?.status;
      if (s && s < 500 && s !== 408 && s !== 429) break;
      if (attempt < 3) await wait(1500 * 2 ** attempt);
    }
  }
  return false;
}
